import React from 'react';
import { useModal } from 'services/modal';
import { ToShortDate } from 'helpers/date';
import RelateDocs from 'scenes/modals/relate-docs';
import { formatNumberToCurrency } from 'helpers/general';
import { TableActionsInbox, TableActionsInboxTypes } from 'ux-thebackyard';
import StateButton from 'components/state-button';
import Translate from 'components/translate';

const Actions = ({ data = {} }) => {
  const { renderComponent } = useModal();
  const handleOpenRelateDocs = () => renderComponent(
    () => <RelateDocs doc={data} />,
    { hideFooter: true },
  );

  const actions = [
    { type: TableActionsInboxTypes.RELATED_DOCS, onClick: handleOpenRelateDocs, tooltipLabel: 'Relacionar documentos' },
  ];

  return (
    <TableActionsInbox actions={actions} />
  );
};

const heads = [
  'actions',
  'number',
  'issuing_rfc',
  'receiver_rfc',
  'total',
  'date',
  'state',
];

const transmuter = (data) => {
  const {
    date, noOrdenC, rfcIssuer, rfcReceiver, total,
  } = data;

  return [
    <Actions data={data} />,
    noOrdenC,
    rfcIssuer,
    rfcReceiver,
    formatNumberToCurrency(total),
    ToShortDate(date, 'string'),
    <StateButton data={data} />,
  ];
};

export default {
  heads: heads?.map((head) => <Translate label={head} />),
  transmuter,
};
